module.exports = __webpack_public_path__ + "images/info-circle-6bf75a42.svg";